import React from 'react';
import { EffectsModal } from '../EffectsModal';

export const DamageModal = ({ title }) => EffectsModal({
  title,
  content: (
    <div>
      <p>The value in the Damage column should be multiplied by 1,000,000 to obtain the actual dollar amount.</p>
      <p>
        When a dollar amount for damage was found in the literature, it was listed in the Damage column in millions of U.S. dollars. The dollar value listed is the value at the time of the event. To convert the damage to current dollar values, please use the
        {' '}
        <a href="https://www.bls.gov/data/inflation_calculator.htm" target="_blank" rel="noopener noreferrer">Consumer Price Index Calculator</a>
        . Monetary conversion tables for the time of the event were used to convert foreign currency to U.S. dollars.
      </p>
    </div>
  ),
});
